module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/necklaces/diamond-8cd4b0b9012e9bce506f26551f27eb34.webp";